const SHIMMER_STYLE_ID = 'storeeel-media-shimmer-style';
const SHIMMER_DELAY_MS = 500;

const clearPendingShimmerTimer = (wrapperEl) => {
  if (!wrapperEl?._storeeelMediaShimmerTimerId) return;
  clearTimeout(wrapperEl._storeeelMediaShimmerTimerId);
  wrapperEl._storeeelMediaShimmerTimerId = null;
};

export const injectMediaShimmerStyles = () => {
  if (document.getElementById(SHIMMER_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = SHIMMER_STYLE_ID;
  style.textContent = `
    .slide-media-wrapper.storeeel-media-loading::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(
        110deg,
        rgba(255, 255, 255, 0.06) 8%,
        rgba(255, 255, 255, 0.18) 18%,
        rgba(255, 255, 255, 0.06) 33%
      );
      background-size: 200% 100%;
      animation: storeeel-shimmer 1.1s linear infinite;
      z-index: 2;
      pointer-events: none;
    }

    @keyframes storeeel-shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `;
  document.head.appendChild(style);
};

export const showMediaLoadingShimmer = (wrapperEl) => {
  if (!wrapperEl) return;
  injectMediaShimmerStyles();
  clearPendingShimmerTimer(wrapperEl);
  // 読み込みが短いケースではシマーを出さず、0.5秒以上待った時だけ表示する。
  wrapperEl._storeeelMediaShimmerTimerId = window.setTimeout(() => {
    wrapperEl.classList.add('storeeel-media-loading');
    wrapperEl._storeeelMediaShimmerTimerId = null;
  }, SHIMMER_DELAY_MS);
};

export const hideMediaLoadingShimmer = (wrapperEl) => {
  if (!wrapperEl) return;
  clearPendingShimmerTimer(wrapperEl);
  wrapperEl.classList.remove('storeeel-media-loading');
};
